module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("one")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Lake Winnipesaukee")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0003.jpg",
      "src": "images/e9781439611975_i0003.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("An aerial view of Lake Winnipesaukee, with Bear Island in the center and the Belknap Mountain Range in the distance to the right. Lake Winnipesaukee is the largest, loveliest, and most picturesque watersheet in New Hampshire. It is not difficult to understand why it holds such a high place in the affections of tourists and natives alike, for there are few lakes in all the world so superbly and magnificently endowed with the scenery, climate, history, and social life that make up this ideal place. Large in area, picturesque in conformation, and with water of crystalline purity, its shores are indented with romantic coves and harbors and are enclosed by tiers of green mountains and hills that attain their crescendo in majestic Mount Washington itself.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "77%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0004.jpg",
      "src": "images/e9781439611975_i0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A view of Lake Winnipesaukee facing Northwest. Shining like silvered glass, this great lake and its countless green islands appear to be a painted map. Here and there upon its dimpling surface glide the steamers of the past and the motor-craft, sailboats, and canoes of today; but these are more incidental, for the time is unnoticed in the wonderful ensemble of the picture itself. In the middle foreground lies the most spacious portion of the lake, The Broads, wherein a fleet of war vessels might readily maneuver. These, with the clustering islands and the majestic background of hills and mountains stretching away into the illimitable north, are the pictures that first come to mind.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "75%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0005.jpg",
      "src": "images/e9781439611975_i0005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A view of Lake Winnipesaukee from the Summit of Red Hill. In geometrical terms, it is impossible to give any adequate description of Lake Winnipesaukee’s conformation. It might, however, be compared to a great aqueous centipede. Its innumerable bays, lagoons, and coves sprawl in every conceivable direction, and its islands appear in the most unexpected places. In its scenic confusion it is emphatically picturesque. The lake is approximately 21 miles long and 12 miles wide at its widest point; its area, exclusive of its islands, is about 72 square miles. If one were to walk the entire mainland shore, he would be obliged to cover a distance equal to that between Boston and St. Johnsbury, Vermont, or 186 miles.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "75%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0006.jpg",
      "src": "images/e9781439611975_i0006.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Lake Winnipesaukee. It was largely through glacial action that this vast antechamber to the White Mountains was formed. The influence of the Ice Age can be readily studied in the conformation of its surrounding mountains, and in the physical characteristics of the lake itself. To its origin it owes not only its remarkable shape, but also the crystal clarity of its water, an important factor in making Winnipesaukee the great natural sanitarium that it is.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "76%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0007.jpg",
      "src": "images/e9781439611975_i0007.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Hooksett Falls on the Merrimack River. This is the major outlet for Lake Winnipesaukee. When the great dam broke at Lakeport, an immense flow of water must have started in that direction. Probably the bulk of the water first flowed through the valley comprising the present Intervale and Lily Pond section, east of the White Oaks hill. However, it is obvious that there was another channel west of the White Oaks, at what is now the Weirs, and that the waters scoured out this channel so rapidly that it eventually became lower than the Intervale channel, until it constituted the only outlet for the lake.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "76%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0008.jpg",
      "src": "images/e9781439611975_i0008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Roberts Cove, during the Winter from Meredith Neck. Insofar as there are no important streams entering the lake, it is obvious that its waters must be fed by subsequeous springs. Merrymeeting and Smith’s River on the southern extremity of the lake are the principal streams, but there are numerous others that are more properly designated brooks. So clear and pellucid are the lake waters that the fish, whose presence make the lake such a favorite resort of the followers of Walton, may plainly be discerned indulging in their social division many feet below the surface.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "75%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0009.jpg",
      "src": "images/e9781439611975_i0009.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Centre Harbor Bay and Village with Red Hill in the distance. The many verdant islands that dot the surface of the lake, making tortuous channels for the navigator, are mostly devoid of precipitous shores. These islands not only add much to the fascination of life on the great lake, but are often marked by interesting history and tradition. Some are owned or leased by clubs, some are privately owned by wealthy city folk, others are in a semipublic status. Still others are no man’s land, too small and insignificant to merit the dignity of ownership.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "76%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0010.jpg",
      "src": "images/e9781439611975_i0010.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Lake Winnipesaukee and Mount Belknap. On many of these lovely wooded islands there are boys’ and girls’ camps, outing clubs, and the like. Other islands harbor only a single family, whose members are able to enjoy a solitude which might be found only in the remote mountains.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "75%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0011.jpg",
      "src": "images/e9781439611975_i0011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Northern Bay with Mile Island on the left. There are boatmen of the lake who know every island, inlet, and rock quite intimately, just as they know the likeliest lurking places of trout, bass, and salmon; however, few of us have the complete knowledge of the real beauty and fascination of life upon this domain.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0012.jpg",
      "src": "images/e9781439611975_i0012.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("The Forties")]), _vm._v("—an image from Kimball’s Castle on Belknap Point. This panorama is but a glimpse of Winnipesaukee’s 186 miles, which represents the entire distance around the lake. Winnipesaukee, the queen of all New England lakes, still reigns with undimmed glory over an annually increasing host of loyal subjects. She has such a vast store of water, scenery, and bracing air, that even the thousands of us who have been drawn to her shores and plied the waters seem at times to be lost in her immensity; thousands more will be added and their presence scarcely noticed.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "76%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0013.jpg",
      "src": "images/e9781439611975_i0013.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("A map of Lake Winnipesaukee, created by the Boston and Maine Railroad, 1909. There are more than 1,300 ponds and lakes, four large river systems, and hundreds of rivers and brooks adorning New Hampshire’s 9,341 square miles. All of these bodies of water have their allure, from the mighty Androscoggin to the gleaming expanse of Winnipesaukee to the reflected beauty of little ponds like the Bear Camp in Sandwich. Nearly every mountain has its clear-watered brooks and cascades, such as Beede Falls in Sandwich Notch. Tarns that are serenity itself are frequently hidden from the highways, but are richly rewarding to the fisherman or the appreciative visitor to our Lakes Region of New Hampshire.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "75%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0014.jpg",
      "src": "images/e9781439611975_i0014.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Lake Winnipesaukee, Bear Island, and Ossipee Mountain from Meredith Neck, NH, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c")]), _vm._v(". 1900.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "38%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0015.jpg",
      "src": "images/e9781439611975_i0015.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Mentor of the Lake, Weirs, NH. Lake Winnipesaukee has been the subject of many tales that have originated and spread throughout our countryside. The most popular of these concern the legends of the Native Americans and early settlers in the Winnipesaukee valley.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "76%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0016.jpg",
      "src": "images/e9781439611975_i0016.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("“The Smile of the Great Spirit” and “Beautiful Water in a High Place.” The name Winnipesaukee itself has caused much controversy among authorities because it can be translated a number of ways. In the Abenaki language, “Ogee” means “the Great Spirit,” and “Winni” means “smiling”; thus, Winnipesogee has an English translation meaning “The Smile of the Great Spirit.” Another translation is “Auke,” meaning “a high place”; thus, we have Winnipesaukee translated into “Beautiful Water in a High Place.”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "76%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0017.jpg",
      "src": "images/e9781439611975_i0017.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Statue of Chief Chocorua in Clough Park in Meredith Bay, Lake Winnipesaukee. This statue is an acknowledgment of the spirit of the Native Americans and their respect for their homeland. The greatest activity of the Native Americans took place on the west shore at the Weirs and Meredith, where Aquadoctan, the largest of the settlements, was located.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Aquadoctan is a Sokoki name meaning “the Weirs.” The Weirs derived its name from an Indian fishing weir, which is a triangular enclosure of rocks and logs used for trapping fish. The weir permitted water to flow freely down the channel but trapped shad in an enclosure of triangular networks. It is said that the original weir, located near Endicott Rock, may still be seen today in those deep waters.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Early native tribes had many camping and hunting grounds throughout the Lakes Region, some of them being at the Pemigewasset Lakes, Waukewan, Moultonboro, Wolfeboro, Alton Bay, Lake Wicwas, and many of the small ponds in central New Hampshire. As you can see from the map on p.18, most of their activities were centered around Lake Winnipesaukee.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "76%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439611975_i0018.jpg",
      "src": "images/e9781439611975_i0018.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Native American Trails in the Lakes Region of New Hampshire.")])])])])])]), _c('a', {
    attrs: {
      "id": "title2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d5fd594","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439611975_c01.vue
// module id = 75
// module chunks = 0